'use strict';
const angular = require('angular');

export class TaskShowComponent {
  /*@ngInject*/
  constructor(ViolationTicketsService, WorkOrderTicketsService, ServiceRequestTicketsService,
              CommunityService, PropertyService, ContactService, VendorService, CustomEntityService) {
    this.ViolationTicketsService = ViolationTicketsService;
    this.WorkOrderTicketsService = WorkOrderTicketsService;
    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
    this.CommunityService = CommunityService;
    this.PropertyService = PropertyService;
    this.ContactService = ContactService;
    this.VendorService = VendorService;
    this.CustomEntityService = CustomEntityService;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    this.task = this.config.data;

    if (this.task.context && this.task.context.type != 'unbound') {
      let contextId = this.task.context.reference;
      let type = this.task.context.type;
      if (type == 'violation') {
        this.ViolationTicketsService.get({id: contextId}, ccr => {
          this.context = `<a href="/violation/ticket/detail/${ccr._id}">${ccr.code}: ${ccr.name}</a>`;
        });
      } else if (type == 'workorder') {
        this.WorkOrderTicketsService.get({id: contextId}, wo => {
          this.context = `<a href="/workorder/ticket/detail/${wo._id}">${wo.code}: ${wo.name}</a>`;
        });
      } else if (type == 'servicerequest') {
        this.ServiceRequestTicketsService.get({id: contextId}, sr => {
          this.context = `<a href="/servicerequest/ticket/detail/${sr._id}">${sr.code}: ${sr.name}</a>`;
        });
      } else if (type == 'community') {
        this.CommunityService.get({id: contextId}, cmty => {
          this.context = `<a href="/community/${cmty._id}">${cmty.code}: ${cmty.name}</a>`;
        });
      } else if (type == 'property') {
        this.PropertyService.get({id: contextId}, cmty => {
          this.context = `<a href="/property/${cmty._id}">Property ${cmty.address.street}, ${cmty.address.city}</a>`;
        });
      } else if (type == 'contact') {
        this.ContactService.get({id: contextId}, contact => {
          this.context = `<a href="/contact/${contact._id}">${contact.firstName} ${contact.middleName || ''} ${contact.lastName}</a>`;
        });
      } else if (type == 'vendor') {
        this.VendorService.get({id: contextId}, vendor => {
          this.context = `<a href="/vendor/${vendor._id}">${vendor.name}</a>`;
        });
      } else if (type == 'entity') {
        this.CustomEntityService.get({id: contextId}, entity => {
          this.context = `<a class="text-capitalize" href="/custom/${entity.schemaSettings}/${entity._id}">${entity.schemaSettings}</a>`;
        });
      }
    }
  };

  ok() {
    this.close({$value: this.task});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.taskShow', [])
  .component('taskShow', {
    template: require('./task-show.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: TaskShowComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/task-show/task-show.component.js